import api from "@/api";
import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const activeRowModal: any = ref({});
const activeDraft: any = ref({});
import { notify } from "@kyvg/vue3-notification";
import EventBus from "@/helpers/EventBus";
import $ from "jquery";
import proposedUniqueBlocks from "@/views/pages/proposedUniqueBlocks.vue";

const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    title: "proposedUniqueBlockFilter",
    pageName: "ProposedUniqueBlockPage",
    genre: "proposedUniqueBlock",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        selectedLabel: null,
        vmodel: "",
        param: "groupGuid",
        apiEquivalent: "groupIds",
        data: [],
      },
      {
        title: "type",
        type: "select",
        apiEquivalent: "type",
        vmodel: null,
        param: "eventTypeName",
        source: "Defination/GetEventTypes",
        data: [],
      },
      // {
      //   title: "type",
      //   apiEquivalent: "eventTypeKeyword",
      //   type: "wordstyped",
      //   param: "eventTypeKeyword",
      // },
      {
        title: "severity",
        type: "select",
        apiEquivalent: "severity",
        vmodel: null,
        param: "value",
        data: [
          {
            id: "Default",
            value: "Default",
          },
          {
            id: "Low",
            value: "Low",
          },
          {
            id: "Medium",
            value: "Medium",
          },
          {
            id: "High",
            value: "High",
          },
          {
            id: "Critical",
            value: "Critical",
          },
        ],
      },
      {
        title: "facility",
        type: "select",
        apiEquivalent: "facility",
        vmodel: null,
        param: "facilityName",
        value: "id",
        source: "Defination/GetFacilities",
        data: [],
      },
      {
        title: "operationsys",
        type: "select",
        vmodel: null,
        param: "osName",
        apiEquivalent: "os",
        source: "Defination/GetOsList",
        data: [],
      },
      {
        title: "code",
        apiEquivalent: "code",
        type: "wordstyped",
        param: "code",
      },
      {
        title: "commandLine",
        apiEquivalent: "commandLine",
        type: "wordstyped",
        param: "username",
      },
      {
        title: "policyFileVersion",
        apiEquivalent: "policyFileVersion",
        type: "wordstyped",
        param: "username",
      },
      {
        title: "eventcount",
        type: "select",
        apiEquivalent: "eventCount",
        vmodel: null,
        param: "label",
        data: [
          {
            label: "<=1000",
            id: 100,
          },
          {
            label: "<=2000",
            id: 3000,
          },
          {
            label: "<=5000",
            id: 5000,
          },
          {
            label: "Greater Than",
            id: "greater",
            showTextInput: true,
            textInputApiEquivalent: "count",
          },
        ],
      },
      {
        title: "membershiptype",
        type: "select",
        apiEquivalent: "memberShipType",
        vmodel: null,
        param: "membershipTypeName",
        source: "Defination/GetMembershipTypes",
        data: [],
      },
      {
        title: "agentversion",
        apiEquivalent: "agentVersion",
        type: "wordstyped",
        param: "username",
      },
      {
        title: "username",
        type: "wordstyped",
        apiEquivalent: "user",
        param: "user",
      },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
      {
        title: "Policy Distribution Time",
        type: "policy",
        vmodel: "",
        apiEquivalent: "policyDownloadDate",
        param: "name",
        data: [],
      },
    ],
  },
  models: {
    draftUpdate: {
      riskLevel: 0,
      permissionLevel: 0,
      allowSigned: 0,
      allowTpl: 0,
      memoryGuard: 0,
      notes: null,
    },
  },
  header: {
    title: "proposedUniqueBlocks",
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        // {
        //   label: "mode",
        //   field: "mode",
        //   sortable: false,
        // },
        {
          label: "type",
          field: "discveryOrEnforce",
          sortable: true,
        },
        {
          label: "blocktype",
          field: "blockType",
          sortable: true,
        },
        {
          label: "action",
          field: "action",
          sortable: true,
        },
        {
          label: "actor",
          field: "actor",
          sortable: true,
        },
        {
          label: "target",
          field: "target",
          sortable: true,
        },
        // {
        //   label: "ancestorList",
        //   field: "ancestorList",
        //   sortable: false,
        //   display: function (row: any) {
        //     if(!row.ancestorList) {
        //       return 0;
        //     }
        //     return row.ancestorList.map((f: any) => {
        //       return f.Path + "<br/><br/>";
        //     });
        //   },
        // },
        {
          label: "ancestorList",
          onclick: (row: any) => {
            store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, row);
          },
          display: function (row: any) {
            if (row.ancestorList) {
              return `<a
              data-toggle="modal"
              data-target="#exampleModalCenterSecondary"
              href="#"
              class="name-btn"
              >${row.ancestorList.length}</a
            >`;
            } else {
              return 0;
            }
          },
        },
        // {
        //   title: "scopedetails",
        //   component: "ag-scope-detail",
        //   options: [true],
        // },
        {
          label: "computerCount",
          field: "computerCount",
          sortable: true,
        },
        {
          label: "totalCount",
          field: "totalCount",
          sortable: true,
        },
        {
          label: "",
          field: "edit",
          display: function (row: any) {
            activeDraft.value.data = row;
          },
          components: [
            {
              component: "tableExpandComponent",
            },
          ],
        },
      ],
      dateFilter: true,
      rows: [],
      total: 0,
      sortable: {
        order: "",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "Save",
        function: async function (arg: any) {
          const body = {
            blockType: store.state.general.selectedExpandedRow.blockType,
            eventId: store.state.general.selectedExpandedRow.eventId,
            riskLevel: data.models.draftUpdate.riskLevel,
            permissionLevel: data.models.draftUpdate.permissionLevel,
            allowSigned: data.models.draftUpdate.allowSigned,
            allowTpl: data.models.draftUpdate.allowTpl,
            memoryGuard: data.models.draftUpdate.memoryGuard,
            notes: data.models.draftUpdate.notes,
            changeReason: "",
          };
          await store.dispatch(GeneralActionTypes.CREATE_REVIEW, body);
          $($("#exampleModalCenter")[0]).removeClass("show");
          $($("#exampleModalCenter")[0]).css("display", "none");
          $("body").removeClass("modal-open");
          $(".modal-backdrop").remove();
          proposedUniqueBlocks.getList();
          notify({
            title: "Saved",
            type: "success",
            duration: 4000,
          });
          // location.href = "/policies/policy-change-checklist/draftreviews"
        },
      },
      display: function (row: any) {
        activeRowModal.value.data = row;
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "draftreview",
          component: "ag-draft-review",
          options: { activeRowModal, activeDraft },
        },
      ],
    },
    {
      id: "exampleModalCenterSecondary",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Ok",
      },
      items: [
        {
          title: "ancestorList",
          component: "ag-ancestor-list",
          options: [true],
        },
      ],
    },
  ],
};

export default data;
